import ServiceDetailBook from "./ServiceDetailBook";
import ServiceDetailFind from "./ServiceDetailFind";
import ServiceDetailGallery from "./ServiceDetailGallery";
import ServiceDetailHead from "./ServiceDetailHead";
import ServiceDetailPerform from "./ServiceDetailPerform";
import ServiceDetailRange from "./ServiceDetailRange";
import ServiceDetailSlide from "../ServiceDetail/ServiceDetailSlide";
import ServiceDetailStyle from "./ServiceDetailStyle";
import ServiceDetailProcess from "./ServiceDetailProcess";

export default function ServiceDetail() {

  const imgSlide = [
      { 
        title: 'Style & mood',
        name: 'Elevated Spaces',
        para: 'Sleek false ceilings that enhance ambience while concealing the essentials.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/turnkey-split-1.webp',
        imageB: '../image/turnkey-split-1b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'Everyday Luxury',
        para: 'Immerse yourself in spaces that balance sophistication with everyday ease.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/turnkey-split-2.webp',
        imageB: '../image/turnkey-split-2b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'Timeless Elegance',
        para: 'Contemporary design infused with comfort for spaces that truly feel like home.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/turnkey-split-3.webp',
        imageB: '../image/turnkey-split-3b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'Productive Aesthetics',
        para: 'Furniture that blends style, comfort, and productivity for the modern workspace.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/turnkey-split-4.webp',
        imageB: '../image/turnkey-split-4b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'Lasting Impressions',
        para: 'Flooring that combines durability with aesthetic appeal for everyday living.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/turnkey-split-5.webp',
        imageB: '../image/turnkey-split-5b.webp',
      },
    ]


  const methodData = {
    heading: "home interior-design planning process (HIDPP)",
    processSteps: [
      {
        left: {
          count: "01",
          title: "Identify your needs",
          desc: "Understand your lifestyle and priorities to determine what your space truly needs to support daily living.",
          img: "../image/turnkey-process-1.webp",
        },
        right: {
          count: "02",
          title: "Space planning",
          desc: "Organize layouts and furniture placement to maximize flow, functionality, and balance within each area.",
          img: "../image/turnkey-process-2.webp",
        },
      },

      {
        left: {
          count: "03",
          title: "Make a draft design for each Space",
          desc: "Create detailed layouts that define the look, flow, and functionality of each space with clarity and vision.",
          img: "../image/turnkey-process-3.webp",
        },
        right: {
          count: "04",
          title: "Select a theme",
          desc: "Choose a cohesive design theme that reflects your personality and unifies every space beautifully.",
          img: "../image/turnkey-process-4.webp",
        },
      },

      {
        left: {
          count: "05",
          title: "Select a designer and execution partner",
          desc: "Choose a trusted designer and execution partner to bring your vision to life with precision and creativity.",
          img: "../image/turnkey-process-5.webp",
        },
        right: {
          count: "06",
          title: "Initial budget estimate",
          desc: "Prepare an initial budget estimate to align design goals with practical and transparent cost planning.",
          img: "../image/turnkey-process-6.webp",
        },
      },

      {
        left: {
          count: "07",
          title: "Design, material and product selection",
          desc: "Select designs, materials, and products that balance aesthetics, durability, and harmony across every space.",
          img: "../image/turnkey-process-7.webp",
        },
        right: {
          count: "08",
          title: "Final budget",
          desc: "Finalize the budget to ensure every design and material choice fits seamlessly within planned costs.",
          img: "../image/turnkey-process-8.webp",
        },
      },

      {
        left: {
          count: "09",
          title: "Project execution",
          desc: "Oversee project execution to ensure every detail is delivered with quality, accuracy, and timely completion.",
          img: "../image/turnkey-process-9.webp",
        },
        right: {
          count: "",
          title: "",
          desc: "",
          img: "../image/turnkey-process-9.webp",
          imgClass: "procs-hideimg", // to hide image
        },
      },
    ],
  };
    
  return (
    <>
    <ServiceDetailHead/>
    <ServiceDetailFind/>
    <ServiceDetailRange/>
    <ServiceDetailGallery/>
    <ServiceDetailProcess methodData={methodData}/>
    {/* <section className="turnkey-stylearea"> <ServiceDetailStyle/> </section> */}
    <ServiceDetailStyle/>
    <ServiceDetailSlide imgSlide={imgSlide}/>
    <ServiceDetailBook/>
    <ServiceDetailPerform/>
    </>
  )
}
